// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD7IE_8kMGs69milIkpPqK6dX2xDwg_SJA",
  authDomain: "zerozband.firebaseapp.com",
  databaseURL: "https://zerozband-default-rtdb.firebaseio.com",
  projectId: "zerozband",
  storageBucket: "zerozband.firebasestorage.app",
  messagingSenderId: "163918714913",
  appId: "1:163918714913:web:2c54629d4c0d28c7ca6b60",
  //stripePublisherKey:
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const functions = getFunctions(app);
export const db = getFirestore(app);